import type { PropsWithChildren } from 'react'

export interface ILabelProps extends PropsWithChildren {
  type?: 'bright' | 'secondary'
  valid?: boolean
  inline?: boolean
}

export const Label = ({ children, type, valid = true, inline = false}: ILabelProps) => {
  const secondary = `${type === 'secondary' ? 'text-secondary' : ''}`
  const bright = `${type === 'bright' ? 'text-primary-content' : ''}`

  return (
    <label className={`label ${inline ? 'inline' : ''} ${!valid ? 'text-red-600' : ''}`}>
      <span className={`label-text ${secondary} ${bright}`}>{children}</span>
    </label>
  )
}
